import axios from 'axios'
import { Toast } from 'vant';
import router from "../router"
import Vue from 'vue'
// 1.还是需要引入vue-i18n插件
import VueI18n from 'vue-i18n'
import i18n from "@/i18n";
// 2.定义中英文语言包
const messages = {
    en: {
        error:{
            error_400 : 'Server error',
            error_401 : 'Login timeout, please login again!',
            error_404 : 'The server was eaten',
            error_403 : 'Insufficient permissions, please contact the administrator',
            error_all : 'unknown error',
            error_1001 : 'Invalid parameter',
            error_1002 : 'The parameter is null',
            error_1003 : 'Wrong parameter type',
            error_1004 : 'Missing parameter',
            error_2001 : 'User not logged in',
            error_2002 : 'The account does not exist or the password is wrong',
            error_2003 : 'Account has been disabled',
            error_2004 : 'user does not exist',
            error_2005 : 'User already exists',
            error_3001 : 'Creation failed',
            error_4001 : 'The system is busy, please try again later',
            error_5001 : 'Data not found',
            error_5002 : 'Data error',
            error_5003 : 'Data already exists',
            error_6004 : 'The interface address is invalid',
            error_6005 : 'Interface request timeout',
        }
    },
    de: {
        error:{
            error_400 : 'Fehler beim Server',
            error_401 : 'Login Timeout, bitte einloggen!',
            error_404 : 'Der Server wurde gegessen',
            error_403 : 'Unzureichende Berechtigungen, wenden Sie sich bitte an den Administrator',
            error_all : 'Unbekannter Fehler',
            error_1001 : 'Ungültiger Parameter',
            error_1002 : 'Der Parameter ist null',
            error_1003 : 'Falsche Parameterart',
            error_1004 : 'Fehlender Parameter',
            error_2001 : 'Benutzer nicht eingeloggt',
            error_2002 : 'Das Konto existiert nicht oder das Passwort ist falsch',
            error_2003 : 'Account wurde deaktiviert',
            error_2004 : 'Benutzer existiert nicht',
            error_2005 : 'Der Benutzer existiert bereits',
            error_3001 : 'Erstellen fehlgeschlagen',
            error_4001 : 'Das System ist beschäftigt, versuchen Sie es später noch einmal.',
            error_5001 : 'Daten nicht gefunden',
            error_5002 : 'Fehler bei Daten',
            error_5003 : 'Daten existieren bereits',
            error_6004 : 'Die Interface-Adresse ist ungültig',
            error_6005 : 'Zeitlimit der Anfrage',
        }
    },
    cn: {
        error:{
            error_400 : '服务器错误',
            error_401 : '登录超时，请重新登录！',
            error_404 : '服务器被吃了',
            error_403 : '权限不足，请联系管理员',
            error_all : '未知错误',
            error_1001 : '参数无效',
            error_1002 : '参数为空',
            error_1003 : '参数类型错误',
            error_1004 : '参数缺失',
            error_2001 : '用户未登录',
            error_2002 : '账号不存在或密码错误',
            error_2003 : '账号已被禁用',
            error_2004 : '用户不存在',
            error_2005 : '用户已存在',
            error_3001 : '创建失败',
            error_4001 : '系统繁忙，请稍后重试',
            error_5001 : '数据未找到',
            error_5002 : '数据有误',
            error_5003 : '数据已存在',
            error_6004 : '接口地址无效',
            error_6005 : '接口请求超时',
        }
    }
};


//请求拦截器
axios.interceptors.request.use(config=>{
    //请求如果存在token，请求就携带token
    if(window.localStorage.getItem('tokenStr')){
        config.headers['Authorization'] = window.localStorage.getItem('tokenStr');
    }
    if(window.localStorage.getItem('lang'))
    {
        let lang = window.localStorage.getItem('lang');

        if(lang=='cn')
        {
            config.headers['lang'] = 'zh-cn';
        }else if(lang=='en'){
            config.headers['lang'] = 'en-us';
        }else if(lang == 'de'){
            config.headers['lang'] = 'de-de';
        }
    }
    return config;
},error => {
    console.log(error);
});
//响应拦截器
axios.interceptors.response.use(success=>{
    //业务逻辑错误
    if(success.status && success.status === 200) {
        console.log(success.status);
        if(success.data.code==401)
        {
            Toast.fail(i18n.t('error.error_401'));
           // localStorage.removeItem('tokenStr');
           // router.replace("Login");
            return;
        }else if(success.data.code==408){
            Toast.fail(i18n.t('error.error_401'));
            localStorage.removeItem('tokenStr');
            router.replace("Login");
            return;
        }else if(success.data.code==400){
            Toast.fail(i18n.t('error.error_400'));
            return;
        }else if(success.data.code==2002){
            Toast.fail(i18n.t('error.error_2002'));
            return;
        }else if(success.data.code==1001){
            Toast.fail(i18n.t('error.error_1001'));
            return;
        }else if(success.data.code==1002){
            Toast.fail(i18n.t("error.error_1002"));
            return;
        }else if(success.data.code==1003){
            Toast.fail(i18n.t("error.error_1003"));
            return;
        }else if(success.data.code==1004){
            Toast.fail(i18n.t("error.error_1004"));
            return;
        }else if(success.data.code==4001){
            Toast.fail(i18n.t("error.error_4001"));
            return;
        }
        if(success.data.message){
          //  Toast.success({message:success.data.message})
        }
    }
    return success.data;

},error => {
    if(error.response.code ===504 || error.response.code ===404) {
        Toast.fail({message:i18n.t('error.error_404')});
        router.replace('Login');
    }else if(error.response.code ===403 ) {
        this.$toast.fail( i18n.t('error.error_403'));
        router.replace('Login');
    }else if(error.response.code === 401 ) {
        Toast.fail(i18n.t('error.error_401'));
        router.replace('Login');
    }else{
        if(error.response.data.message) {
            Toast.fail(i18n.t('error.error_all'));
            router.replace('Login');
        } else {
            Toast.fail(i18n.t('error.error_all'));
            router.replace('Login');
        }
    }
    return;
});

//let base = '/index';
let base = '';
export const postReq = (url,params)=>{
    return axios({
        method : 'post',
        url :`${base}${url}`,
        data:params
    })
};

export const putReq = (url,params) =>{
    return axios({
        method: 'put',
        url :`${base}${url}`,
        data:params
    })
};

export const getReq = (url,params) =>{
    return axios({
        method: 'get',
        url :`${base}${url}`,
        params:params
    })
};

export const deleteReq = (url,params) =>{
    return axios({
        method: 'delete',
        url :`${base}${url}`,
        data:params
    })
};

export const instance = axios.create({
    baseURL:base,
    timeout:1500,
    headers:{"Conten-Type":"multipart/form-data"}
});
